import { render, staticRenderFns } from "./authLayout.vue?vue&type=template&id=ef8180da"
import script from "./authLayout.vue?vue&type=script&lang=js"
export * from "./authLayout.vue?vue&type=script&lang=js"
import style0 from "./authLayout.vue?vue&type=style&index=0&id=ef8180da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports